<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import noteIcon from "../../static/assets/images/note-1.svg";
import flagIcon1 from "../../static/assets/images/flag-1.svg";

export default {
  name: "Recipe",
  data() {
    return {
      flagIcon1,
      noteIcon,
      limit: 25,
      searchStr: null,
      searchResult: true,
      rows: 3,
      offset: 1,
      fields: [
        {
          key: "title",
          label: "Recipe Name",
          sortable: true,
        },
        {
          key: "effects",
          label: "Benefits",
          sortable: true,
        },
        {
          key: "dietary_preferences",
          label: "Dietary Preference",
          sortable: true,
        },
        {
          key: "categories",
          label: "Category",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      recipes: "recipes/recipes",
      categoriesFieldOptions: "recipes/categoriesFieldOptions",
      dietaryPreferencesOptions: "recipes/dietaryPreferencesOptions",
      dietaryOptions: "recipes/dietaryOptions",
      effectsOptions: "recipes/effectsOptions",
    }),
  },

  mounted() {
    this.$store.dispatch(`recipes/getFieldOptions`);
    this.$store.dispatch(`recipes/getDietaryOptions`);
  },
  methods: {
    next() {
      this.$store.commit("commons/setPreloader", true);
      this.offset = this.offset + 1;
      this.searchResult = true;
      this.$store
        .dispatch("recipes/getRecipes", {
          limit: this.limit,
          offset: this.offset,
          search: this.searchStr,
        })
        .then(
          (res) => {
            this.$store.commit("commons/setPreloader", false);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    prev() {
      this.$store.commit("commons/setPreloader", true);
      this.offset = this.offset - 1;
      this.searchResult = true;
      this.$store
        .dispatch("recipes/getRecipes", {
          limit: this.limit,
          offset: this.offset,
          search: this.searchStr,
        })
        .then(
          (res) => {
            this.$store.commit("commons/setPreloader", false);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    page(number) {
      this.$store.commit("commons/setPreloader", true);
      this.offset = number;
      this.searchResult = true;
      this.$store
        .dispatch("recipes/getRecipes", {
          limit: this.limit,
          offset: this.offset,
          search: this.searchStr,
        })
        .then(
          (res) => {
            this.$store.commit("commons/setPreloader", false);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    countPage() {
      if (this.recipes.count > this.limit) {
        return Math.ceil(this.recipes.count / this.limit);
      }
      return 1;
    },
    changelimit() {
      this.$store.commit("commons/setPreloader", true);
      this.searchResult = true;
      this.$store
        .dispatch("recipes/getRecipes", {
          limit: this.limit,
          offset: 1,
          search: this.searchStr,
        })
        .then(
          (res) => {
            this.$store.commit("commons/setPreloader", false);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    search() {
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("recipes/getRecipes", {
          limit: this.limit,
          offset: this.offset,
          search: this.searchStr,
        })
        .then(
          (res) => {
            this.searchResult = true;
            this.offset = 1;
            this.$store.commit("commons/setPreloader", false);
          },
          (error) => {
            this.searchResult = false;
          }
        );
    },
    clearSearch() {
      if (!this.searchStr) {
        this.search();
      }
    },
    clearSearchClick() {
      this.searchStr = "";
      this.search();
    },
    optionValue(id, type) {
      var data = "";
      if (type == "categories") {
        data =
          this.categoriesFieldOptions && id
            ? this.categoriesFieldOptions.find((option) => option.value == id)
            : null;
      }
      if (type == "effects") {
        data =
          this.effectsOptions && id
            ? this.effectsOptions.find((option) => option.value == id)
            : null;
      }

      if (type == "dietary_preferences") {
        data =
          this.dietaryPreferencesOptions && id
            ? this.dietaryPreferencesOptions.find(
                (option) => option.value == id
              )
            : null;
      }

      if (type == "dietary_preferences") {
        data =
          this.dietaryOptions && id
            ? this.dietaryOptions.find((option) => option.value == id)
            : null;
      }

      if (data) return data.text;
    },
  },
};
</script>
<style lang="scss">
table {
  thead {
    th {
      &.icon-table-header {
        width: 20px;
        & > div {
          font-size: 0;
          width: 22px;
          height: 22px;
          background-position: center !important;
          background-size: cover !important;
          margin-right: 10px !important;
          cursor: pointer;
        }
        &.flag-table {
          & > div {
            background-image: var(--flagIcon1);
          }
        }
        &.note-table {
          & > div {
            background-image: var(--noteIcon);
          }
        }
      }
    }
  }
  tbody {
    td {
      &.icon-table-header {
        text-align: center;
      }
    }
  }
}
</style>

  
<template>
  <div
    class="data-list"
    :style="{
      '--flagIcon1': 'url(' + flagIcon1 + ')',
      '--noteIcon': 'url(' + noteIcon + ')',
    }"
  >
    <div class="filter d-flex align-items-center">
      <b-input-group>
        <b-form-input
          v-model="searchStr"
          type="text"
          placeholder="Search recipe by name, status, …"
          v-on:keyup.enter="search"
        ></b-form-input>
        <b-input-group-append>
          <b-input-group-text class="mr-2">
            <b-icon icon="search" v-if="!searchStr" />
            <b-icon
              icon="x-circle-fill"
              class="text-danger cursor-pointer"
              @click="clearSearchClick()"
              v-if="searchStr"
            />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <b-input-group-append>
        <b-button
          text="Button"
          variant="primary bg-white text-primary"
          @click="search()"
          >FILTER</b-button
        >
      </b-input-group-append>
    </div>

    <b-table
      :sticky-header="true"
      responsive
      :fields="fields"
      :items="recipes.results"
      v-if="searchResult"
    >
      <template #cell(title)="data">
        <b>
          <a v-bind:href="`#/recipe/${data.item.id}/`">
            {{ data.item.title }}
          </a>
        </b>
      </template>

      <template #cell(effects)="data">
        <div>
          <span
            v-for="item in data.item.effects"
            :key="item.id"
            class="badge inline-block regular"
          >
            {{ optionValue(item, "effects") }}
          </span>
        </div>
      </template>

      <template #cell(dietary_preferences)="data">
        <div>
          <span
            v-for="item in data.item.dietary_preferences"
            :key="item.id"
            class="badge inline-block regular"
          >
            {{ optionValue(item, "dietary_preferences") }}
          </span>
        </div>
      </template>

      <template #cell(categories)="data">
        <div>
          <span
            v-for="item in data.item.categories"
            :key="item.id"
            class="badge inline-block regular"
          >
            {{ optionValue(item, "categories") }}
          </span>
        </div>
      </template>

      <template #cell(status)="data">
        <span class="badge inline-block" :class="data.item.status">{{
          data.item.status
        }}</span>
      </template>
    </b-table>

    <h2 v-if="!searchResult" class="text-center py-5">
      No "{{ searchStr }} " found
    </h2>

    <div
      class="
        pagination-wrapper
        d-flex
        justify-content-between
        align-items-center
        w-100
      "
      v-if="searchResult"
    >
      <div class="total">{{ recipes.count }} results</div>
      <div class="pagination">
        <ul
          role="menubar"
          aria-disabled="false"
          aria-label="Pagination"
          class="pagination b-pagination"
          v-if="countPage() != 1"
        >
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="recipes.previous"
          >
            <span
              aria-label="Go to previous page"
              class="page-link text-primary"
              @click="prev()"
            >
              <b-icon icon="chevron-left" aria-hidden="true"></b-icon
            ></span>
          </li>
          <li
            class="page-item"
            v-for="item in countPage()"
            :key="item"
            :class="item == offset ? 'active' : ''"
          >
            <button class="page-link" @click="page(item)">{{ item }}</button>
          </li>
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="recipes.next"
          >
            <span
              aria-label="Go to next page"
              class="page-link text-primary"
              @click="next()"
            >
              <b-icon icon="chevron-right" aria-hidden="true"></b-icon
            ></span>
          </li>
        </ul>
      </div>
      <div
        class="
          dropdown-pagination
          d-flex
          justify-content-end
          align-items-center
        "
      >
        <b-form-group class="select">
          <b-form-select v-model="limit" @change="changelimit()">
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-form-select>
        </b-form-group>
        Per page
      </div>
    </div>
  </div>
</template>